'use client';

import { ComponentProps, forwardRef, useState } from 'react';

import Link from 'next/link';

type NextLinkProps = ComponentProps<typeof Link>;

export const PrefetchLink = forwardRef<HTMLAnchorElement, NextLinkProps>(({ children, ...rest }, ref) => {
  const [prefetch, setPrefetch] = useState(false);

  return (
    <Link {...rest} ref={ref} prefetch={prefetch} onMouseEnter={() => setPrefetch(true)}>
      {children}
    </Link>
  );
});

PrefetchLink.displayName = 'PrefetchLink';
